<template>
    <div class="home">
        <my-swiper :imgs="imgs"></my-swiper>
        <selection></selection>
        <category></category>
        <about></about>
        <honor></honor>
        <partner></partner>
        <div class="bg-child"></div>
    </div>
</template>

<script>
export default {
    name: "home",
    components: {
        mySwiper: () => import("../components/swiper.vue"),
        selection: () => import("../components/home/selection.vue"),
        category: () => import("../components/home/category.vue"),
        about: () => import("../components/home/about.vue"),
        honor: () => import("../components/home/honor.vue"),
        partner: () => import("../components/home/partner.vue")
    },
    data() {
        return {
            imgs: [
                // require("imgdir/index/banner1.jpg"),
                // require("imgdir/index/banner2.jpg"),
                {
                    url: require("imgdir/index/banner1.jpg"),
                    action: '/about'
                },
                {
                    url: require("imgdir/index/banner2.jpg"),
                    action: '/investment'
                }
            ],
        };
    }
};
</script>
